import React, { FC, useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'
import { WasteType } from '../../../core/domain/models'
import SearchInput from '../../shared/SearchInput'
import WasteList from './WasteList'

interface AvailableWasteTypesModalProps {
  name: string
  wasteTypes: Array<WasteType>
  onClose: () => void
}

const AvailableWasteTypesModal: FC<AvailableWasteTypesModalProps> = ({ name, wasteTypes, onClose }) => {
  const intl = useIntl()

  const [wastes, setWastes] = useState<Array<WasteType>>(wasteTypes)
  const [searchInputValue, setSearchInputValue] = useState<string>('')

  const onSearchInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target
    setSearchInputValue(value)
    setWastes(wasteTypes.filter((waste) => waste.name.toLowerCase().includes(value.toLowerCase())))
  }

  return (
    <Container>
      <Title>
        <FormattedMessage id="DropOffLocation.lists.availableWastes" />
      </Title>
      <Name>
        <FormattedMessage id="DropOffLocation.lists.at" /> {name}
      </Name>
      <InputSearchWrapper>
        <SearchInput
          placeholder={intl.formatMessage({ id: 'DropOffLocation.list.search' })}
          onChange={onSearchInputChange}
          value={searchInputValue}
        />
      </InputSearchWrapper>
      <WasteList wastes={wastes} />
      <CloseButton type="button" onClick={() => onClose()}>
        {intl.formatMessage({ id: 'DropOffLocation.list.close' })}
      </CloseButton>
    </Container>
  )
}

const Container = styled.div`
  width: 413px;
`

const InputSearchWrapper = styled.div`
  height: 48px;
  width: 100%;
  margin-bottom: 12px;
`

const Title = styled.h1`
  font-weight: ${({ theme }) => theme.weight.bold};
  font-size: ${({ theme }) => theme.size.big};
  line-height: 27px;
`

const Name = styled.h2`
  font-weight: ${({ theme }) => theme.weight.normal};
  font-size: ${({ theme }) => theme.size.small};
  line-height: 18px;
  margin-bottom: 16px;
`
const CloseButton = styled.button`
  font-style: normal;
  font-weight: ${({ theme }) => theme.weight.bold};
  font-size: ${({ theme }) => theme.size.small};
  width: 100%;
  background-color: #ededed;
  border-radius: 4px;
  height: 40px;
  cursor: pointer;
`

export default AvailableWasteTypesModal
